import React, { Fragment, useEffect, useState } from 'react';
import styles from '../../styles.module.scss';
import VendorProgramItem from './vendor-program-item';
import PropTypes from 'prop-types';
import VendorProgramForm from './vendor-program-form';

const VendorProgramList = props => {
  const {
    vendorPrograms,
    showLoading,
    onEditVendorProgram,
    editLoading,
    onDeleteVendorProgram,
    deleteLoading,
    onCreateVendorProgram,
    createLoading,
    isGroup,
    organizationName,
    isSetting,
    hasBillingAccess
  } = props;

  const [vendorProgramList, setVendorProgramList] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);

  useEffect(() => {
    if (vendorPrograms) {
      const updatedVendorPrograms = vendorPrograms.map(item => ({
        ...item,
        showEditForm: false
      }));
      setVendorProgramList(updatedVendorPrograms);
    }
  }, [vendorPrograms]);

  const handleCancelEditForm = (vendorProgram) => {
    const updatedVendorPrograms = vendorProgramList.map(item => ({
      ...item,
      showEditForm: item.vendorProgramId === vendorProgram.vendorProgramId ? false : item.showEditForm
    }));

    setVendorProgramList(updatedVendorPrograms);
  };

  const handleEditVendorProgram = (values, vendorProgram) => {
    onEditVendorProgram(values, vendorProgram);
    handleCancelEditForm(vendorProgram)
  };


  const handleCreateVendorProgram = (values) => {
    onCreateVendorProgram(values)
    setShowCreateForm(false)
  }

  const handleEditButton = (vendorProgram) => {
    const updatedVendorPrograms = vendorProgramList.map(item => ({
      ...item,
      showEditForm: item.vendorProgramId === vendorProgram.vendorProgramId ? true : false
    }));
    setVendorProgramList(updatedVendorPrograms);
    setShowCreateForm(false);
  };

  const handleCreateButton = () => {
    const updatedVendorPrograms = vendorProgramList.map(item => ({
      ...item,
      showEditForm: false
    }));

    setVendorProgramList(updatedVendorPrograms);
    setShowCreateForm(true);
  }

  const renderVendorPrograms = () => vendorProgramList.map((vendorProgram, index) => (
    vendorProgram.showEditForm ?
      <VendorProgramForm
        key={`vendor-program-item-${vendorProgram.vendorProgramId}`}
        vendorProgram={vendorProgram}
        isGroup={isGroup}
        onSubmitForm={handleEditVendorProgram}
        onCancelForm={handleCancelEditForm}
        loading={editLoading}
      />
      :
      <VendorProgramItem
        key={`vendor-program-item-${vendorProgram.vendorProgramId}`}
        index={index}
        vendorProgram={vendorProgram}
        onDeleteVendorProgram={onDeleteVendorProgram}
        deleteLoading={deleteLoading}
        isGroup={isGroup}
        hasBillingAccess={hasBillingAccess}
        onHandleEditButton={handleEditButton}
      />
  ));

  const renderCreateVendorProgram = () => (
    showCreateForm ?
      <VendorProgramForm
        isGroup={isGroup}
        onSubmitForm={handleCreateVendorProgram}
        onCancelForm={() => setShowCreateForm(false)}
        loading={createLoading}
      /> :
      <tr>
        <td className={styles.tableColVendorPoint}></td>
        <td className={styles.tableColCategory}></td>
        <td className={styles.tableColDate}></td>
        <td className={styles.tableColPhoneNumber}></td>
        <td className={styles.tableColWebsite}></td>
        <td className={styles.tableColDescription}></td>
        {isGroup && <td className={styles.tableColOwner}></td>}
        <td className={styles.tableColAction}>
          <a className='create-new-program' onClick={handleCreateButton}>New Program</a>
        </td>
      </tr>
  );

  return (showLoading ? 'Loading...' : <div className={styles.vendorProgramList}>
    {organizationName && <div className={styles.tableTitle}>
      {organizationName}'s Vendor Point Solutions
    </div>}
    <table className={isSetting && styles.scrollTable}>
      <thead>
      <tr>
        <th className={styles.tableColVendorPoint}>Vendor Point</th>
        <th className={styles.tableColCategory}>Category</th>
        <th className={styles.tableColDate}>Effective Start Date</th>
        <th className={styles.tableColPhoneNumber}>Phone number</th>
        <th className={styles.tableColWebsite}>Website</th>
        <th className={styles.tableColDescription}>Description</th>
        {isGroup && <th className={styles.tableColOwner}>Inherited from</th>}
        {hasBillingAccess && <th className={styles.tableColAction}>Action</th>}
      </tr>
      </thead>
      <tbody>
      {renderVendorPrograms()}
      {hasBillingAccess && renderCreateVendorProgram()}
      </tbody>
    </table>
  </div>);
};

VendorProgramList.propTypes = {
  vendorPrograms: PropTypes.array.isRequired,
  onEditVendorProgram: PropTypes.func.isRequired,
  onDeleteVendorProgram: PropTypes.func.isRequired,
  onCreateVendorProgram: PropTypes.func.isRequired,
  isGroup: PropTypes.bool.isRequired,
  showLoading: PropTypes.bool,
  editLoading: PropTypes.bool,
  deleteLoading: PropTypes.bool,
  createLoading: PropTypes.bool,
  organizationName: PropTypes.string,
  isSetting: PropTypes.bool,
  hasBillingAccess: PropTypes.bool
};

export default VendorProgramList;
